import { Option } from '../../../components/Select';
import unescapedText from 'I18n/utils/unescapedText';

let emptyGroup: Option;
export const getEmptyGroup = () => {
  emptyGroup = emptyGroup || {
    disabled: true,
    text: unescapedText('salesUI.UITypeahead.noOptions'),
    value: '__EMPTY_GROUP__',
  };
  return emptyGroup;
};

let noMatchesOption: Option;
export const getNoMatchesOption = () => {
  noMatchesOption = noMatchesOption || {
    disabled: true,
    groupIdx: -1,
    text: unescapedText('salesUI.UITypeahead.noMatchesFound'),
    value: '__EMPTY_OPTION__',
  };
  return noMatchesOption;
};

export const getSearchRegExp = (str: string) => {
  return new RegExp(str.trim().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
};
